// extracted by mini-css-extract-plugin
export default {"section":"CptPile_section__H9wLB","spaceBetween":"CptPile_spaceBetween__3HcOr","rightAlign":"CptPile_rightAlign__V0i7r","banWrapper":"CptPile_banWrapper__dwuei"};